import React from 'react';
import styled from 'styled-components';
import StyleConfig from 'src/constants/StyleConfig';

type Props = {
  color?: 'priamry' | 'secondary' | 'black';
  text: string;
};

export const AnnotaionText = ({ ...props }: Props) => {
  return (
    <Styled color={props.color}>
      <p className="annotaion">{props.text}</p>
    </Styled>
  );
};

const Styled = styled.div`
  .annotaion {
    font-size: 12px;
    color: ${({ color }) => {
      switch (color) {
        case 'primary':
        default:
          return StyleConfig.COLOR.PRIMARY;
        case 'secondary':
          return StyleConfig.COLOR.SECONDORY;
        case 'black':
          return StyleConfig.COLOR.TEXT_COLOR;
      }
    }};
    margin: ${StyleConfig.HELPER.M8} auto;
  }
`;

export default AnnotaionText;
